var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f34edbd6302f0702c226dbe22a67e12b2d34ee98"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["vardhan-ui@rapidcanvas"]={id:"f34edbd6302f0702c226dbe22a67e12b2d34ee98"};
      